import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUnhealthy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={38}
    height={38}
    fill="none"
    aria-label="Unhealthy"
    {...props}
  >
    <path
      fill="#EC4145"
      d="M18.9 3.78c8.35 0 15.12 6.77 15.12 15.12S27.25 34.02 18.9 34.02 3.78 27.25 3.78 18.9 10.55 3.78 18.9 3.78"
    />
    <path
      fill="#FFF"
      d="M25.17 13.102a1.5 1.5 0 0 0-2.12 0l-3.913 3.913-3.914-3.913a1.5 1.5 0 1 0-2.12 2.12l3.913 3.914-3.913 3.913a1.5 1.5 0 0 0 2.12 2.12l3.914-3.912 3.913 3.913a1.5 1.5 0 1 0 2.12-2.121l-3.913-3.913 3.913-3.913a1.5 1.5 0 0 0 0-2.121"
    />
  </svg>
);
export default SvgUnhealthy;
